import { StyleEmptyWrapper, StyleSvgWrapper } from './style'
import Icons from './icons'
export interface IEmpty {
  title?: string
  description?: string
  icon?: any
}
const Empty = ({ icon = 'noDataFound' }: IEmpty) => {
  return (
    <StyleEmptyWrapper>
      <StyleSvgWrapper
        dangerouslySetInnerHTML={{ __html: Icons[icon] }}
        size={200}
      />
    </StyleEmptyWrapper>
  )
}
export default Empty
